import httpClient from '../services/HttpClient'

// eslint-disable-next-line import/prefer-default-export
export const markUserAsViewedTutorial = async ({ commit }) => {
    const response = await httpClient.post('/api/me/ta', {
        hasSeenTutorial: true,
    })
    commit('updateUserMeta', { hasSeenTutorial: response.success })
}
